import { render, staticRenderFns } from "./MonitorParagraphEdit.vue?vue&type=template&id=094f8914&"
import script from "./MonitorParagraphEdit.vue?vue&type=script&lang=js&"
export * from "./MonitorParagraphEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports